module.exports = __webpack_public_path__ + "img/icon_comments.f8641302.svg";